import config from './config'
import axios from 'axios'
import desCode from './aesUtil'
import mdCode from './md5'

let apiUrl = config.apiUrl.dev
if (location.origin == config.originUrl.test) {
    apiUrl = config.apiUrl.test
}

if (location.origin == config.originUrl.prod) {
    apiUrl = config.apiUrl.prod
}


// 登录
export const login11 = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('account=' + params.account + '_password=' + params.password);
    let md = mdCode.hexMD5('8888' + '200' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 200);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

//获取签到列表
export const GetProductionManage = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('PlineNo=' + params.Pline_no + '_BeginTime=' + params.BeginTime + '_EndTime=' + params.EndTime + '_UploadBeginTime=' + params.UploadBeginTime + '_UploadEndTime=' + params.UploadEndTime + '_pageNo=' + params.pageNo + '_pageSize=' + params.pageSize);
    let md = mdCode.hexMD5('8888' + '202' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 202);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

//获取导出数据
export const DownloadProduction = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('PlineNo=' + params.Pline_no + '_BeginTime=' + params.BeginTime + '_EndTime=' + params.EndTime + '_UploadBeginTime=' + params.UploadBeginTime + '_UploadEndTime=' + params.UploadEndTime + '_pageNo=' + params.pageNo + '_pageSize=' + params.pageSize);
    let md = mdCode.hexMD5('8888' + '202' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 202);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

//获取柱状图数据
export const GetData = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('PlineNo=' + params.Pline_no + '_BeginTime=' + params.BeginTime + '_EndTime=' + params.EndTime);
    let md = mdCode.hexMD5('8888' + '203' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 203);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

//获取折线图数据
export const GetDay = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('PlineNo=' + params.Pline_no + '_BeginTime=' + params.Time);
    let md = mdCode.hexMD5('8888' + '204' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 204);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

// 获取日志列表
export const GetLogQueryList = (params) => {
    let formData = new FormData();
    let wMsgID = desCode.wMsgID();
    let wParam = desCode.to3des('Type=' + params.Type + '_BeginTime=' + params.BeginTime + '_EndTime=' + params.EndTime);
    let md = mdCode.hexMD5('8888' + '205' + wMsgID + wParam + 'q1w2e3r4t5y6');
    formData.append('wAgent', 8888);
    formData.append('wAction', 205);
    formData.append('wMsgID', wMsgID);
    formData.append('wParam', wParam);
    formData.append('wSign', md);
    formData.append('wImei', '222');
    formData.append('wVersion', '2');
    formData.append('wRequestUserID', '4');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl, formData, config)
}

//-----------------------new
// 登录
export const login = (params) => {
    let formData = new FormData();

    formData.append('account', params.account);
    formData.append('password', params.password);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'index/weblogin', formData, config)
}

// 获取分类数据
export const GetCategoryList = (params) => {

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.get(apiUrl + 'index/getcategory', config)
}

//保存
export const SaveCategory = (params) => {
    let formData = new FormData();

    formData.append('text', params.text);
    formData.append('for', params.for);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'index/savecategory', formData, config)
}

//---视频
export const GetVideopageList = (params) => {

    let formData = new FormData();

    formData.append('title', params.title);
    console.log('111111111GetVideopageList' + params.title)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.post(apiUrl + 'video/getvideolist', formData, config)
}

//---获取movie类型数据
export const GetcategorybyformovieList = (params) => {

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.get(apiUrl + 'video/categorybyformovie', config)
}


//保存视频
export const SaveVideo = (params) => {
    let formData = new FormData();

    formData.append('videoId', params.videoId);
    formData.append('title', params.title);
    formData.append('description', params.description);
    formData.append('category', params.category);
    formData.append('videoSrc', params.videoSrc);
    formData.append('posterSrc', params.posterSrc);
    formData.append('for', params.for);
    formData.append('listOrder', params.listOrder);

    console.log('111111111SaveVideotitle' + params.title)
    //console.log('111111111SaveVideoid'+params.videoId)
    console.log('111111111SaveVideoid' + params.description)
    console.log('111111111SaveVideoid' + params.category)
    console.log('111111111SaveVideoid' + params.videoSrc)
    console.log('111111111SaveVideoid' + params.posterSrc)
    console.log('111111111SaveVideoid' + params.for)
    console.log('111111111SaveVideoid' + params.listOrder)
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'video/savevideo', formData, config)
}


//---获取所有志愿者活动信息
export const GetaavolunteeractivityList = (params) => {
    console.log('getaavolunteeractivityList' + params)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.get(apiUrl + `banner/getadminaavolunteeractivity?phone=${params.phone}&releasetype=${params.releasetype}&isdelete=${params.isdelete}&examinestate=${params.examinestate}`, config)
}


//-----------------------

//---获取志愿者详情接口
export const getaavolunteeractivityone = (params) => {
    console.log(params)
    let formData = new FormData();
    formData.append('aavolunteeractivityId', params.aavolunteeractivityId);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.get(apiUrl + 'banner/getaavolunteeractivityone?aavolunteeractivityId=' + params.aavolunteeractivityId, formData, config)
}
//-----------------------

//---审核志愿者详情接口
export const setexaminestate = (params) => {
    console.log(params)
    let formData = new FormData();
    formData.append('aavolunteeractivityId', params.aavolunteeractivityId);
    formData.append('examinestate', params.examinestate);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'banner/setexaminestate', formData, config)
}
//---根据活动查询参与人员
export const getaavolunteerlist = (params) => {
    console.log(params)
    let formData = new FormData();
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.get(apiUrl + 'banner/getaavolunteerlist?volunteeractivityId=' + params, formData, config)
}


//---修改志愿者信息上下架
export const setisdelete = (params) => {
    console.log(params)
    let formData = new FormData();
    formData.append('aavolunteeractivityId', params.aavolunteeractivityId);
    formData.append('isdelete', params.isdelete);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'banner/setisdelete', formData, config)
}

//新增志愿者
export const setadminaavolunteeractivity = (params) => {
    let formData = new FormData();
    formData.append('activityname', params.activityname);
    formData.append('name', params.name);
    formData.append('age', params.age);
    formData.append('gender', params.gender);
    formData.append('address', params.address);
    formData.append('phone', params.phone);
    formData.append('needs', params.needs);
    formData.append('remarks', params.remarks);
    formData.append('image', params.image);
    formData.append('aavolunteeractivityId', params.aavolunteeractivityId);

    console.log('setadminaavolunteeractivity' + params)
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'banner/setadminaavolunteeractivity', formData, config)
}
//修改志愿者
export const updateaavolunteeractivity = (params) => {
    let formData = new FormData();
    formData.append('activityname', params.activityname);
    formData.append('name', params.name);
    formData.append('age', params.age);
    formData.append('gender', params.gender);
    formData.append('address', params.address);
    formData.append('phone', params.phone);
    formData.append('needs', params.needs);
    formData.append('remarks', params.remarks);
    formData.append('image', params.image);
    formData.append('aavolunteeractivityId', params.aavolunteeractivityId);

    console.log('setadminaavolunteeractivity' + params)
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(apiUrl + 'banner/updateaavolunteeractivity', formData, config)
}
//---文章列表
export const getArticlelist = (params) => {

    let formData = new FormData();

    formData.append('category', params.category);
    console.log('111111111getArticlelist' + params.category)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.get(apiUrl + 'article/getArticlelist?category=' + params.category, formData, config)
}
//---删除文章
export const delArticlelist = (params) => {
    let formData = new FormData();
    formData.append('articleId', params.articleId);
    console.log('111111111deletearticle' + params.articleId)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.post(apiUrl + 'article/deletearticle', formData, config)
}
//---新增文章
export const addArticlelist = (params) => {
    let formData = new FormData();
    formData.append('articleId', params.articleId);
    formData.append('category', params.category);
    formData.append('title', params.title);
    formData.append('url', params.url);
    formData.append('abstract', params.abstract);
    formData.append('posterUrl', params.posterUrl);
    console.log('111111111savearticle' + params)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.post(apiUrl + 'article/savearticle', formData, config)
}
//---修改文章
export const editArticlelist = (params) => {

    let formData = new FormData();
    formData.append('articleId', params.articleId);
    formData.append('category', params.category);
    formData.append('title', params.title);
    formData.append('url', params.url);
    formData.append('abstract', params.abstract);
    formData.append('posterUrl', params.posterUrl);
    console.log('111111111savearticle' + params)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.post(apiUrl + 'article/updatearticle', formData, config)
}
//-----------------------
//获取七牛token：
export const uploadTokenApi = (params) => {

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    //return axios.get('http://10.0.40.117:930/video/getqiniutoken', config)
    return axios.get(apiUrl + 'video/getqiniutoken', config)
}

export const uptoken11111 = () => {
    let formData = new FormData();

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    //return axios.get('http://10.0.40.117:930/video/getqiniutoken',  config)
    return axios.get(apiUrl + 'video/getqiniutoken', config)
}

//上传到七牛云
export const uploadss = (params) => {
    let formData = new FormData();

    formData.append('file', params.file);
    formData.append('token', params.token);
    formData.append('key', params.key);

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return axios.post('http://up-z2.qiniu.com', formData, config)
}

export const removeFilesApi = (params) => {


}
